
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, LabelId_$reflection, CustomIntervalDefinition_$reflection, ReminderInterval_$reflection, RequestedValue$1_$reflection, InspectionTemplateId_$reflection } from "../../../Shared/Shared.js";
import { array_type, anonRecord_type, int32_type, class_type, record_type, option_type, string_type, bool_type, list_type, union_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Label_$reflection } from "../../../Shared/Category.js";
import { DTO_InspectionTemplateDetailDto_$reflection } from "../../../Shared/InspectionTemplate.js";

export class FormMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Create", "Edit"];
    }
}

export function FormMode_$reflection() {
    return union_type("Settings.InspectionTemplate.Form.Types.FormMode", [], FormMode, () => [[], [["Item", InspectionTemplateId_$reflection()]]]);
}

export class State extends Record {
    constructor(FormMode, Categories, TemplateLoaded, Name, Description, Interval, CustomInterval, NotificationInterval, SuccessfulResults, FailedResults, SelectedCategoryIds, IsUsed, FormState) {
        super();
        this.FormMode = FormMode;
        this.Categories = Categories;
        this.TemplateLoaded = TemplateLoaded;
        this.Name = Name;
        this.Description = Description;
        this.Interval = Interval;
        this.CustomInterval = CustomInterval;
        this.NotificationInterval = NotificationInterval;
        this.SuccessfulResults = SuccessfulResults;
        this.FailedResults = FailedResults;
        this.SelectedCategoryIds = SelectedCategoryIds;
        this.IsUsed = IsUsed;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.InspectionTemplate.Form.Types.State", [], State, () => [["FormMode", FormMode_$reflection()], ["Categories", RequestedValue$1_$reflection(list_type(Label_$reflection()))], ["TemplateLoaded", bool_type], ["Name", string_type], ["Description", string_type], ["Interval", ReminderInterval_$reflection()], ["CustomInterval", option_type(CustomIntervalDefinition_$reflection())], ["NotificationInterval", option_type(CustomIntervalDefinition_$reflection())], ["SuccessfulResults", list_type(string_type)], ["FailedResults", list_type(string_type)], ["SelectedCategoryIds", list_type(LabelId_$reflection())], ["IsUsed", bool_type], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TemplateFetched", "CategoriesFetched", "FetchError", "SetName", "SetDescription", "SetInterval", "SetCustomInterval", "SetNotificationEnabled", "SetNotificationInterval", "SetSuccessfulResults", "SetFailedResults", "SetSelectedCategoryIds", "SaveTemplate", "TemplateSaved", "SaveError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.InspectionTemplate.Form.Types.Msg", [], Msg, () => [[["Item", DTO_InspectionTemplateDetailDto_$reflection()]], [["Item", list_type(Label_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", string_type]], [["Item", string_type]], [["Item", ReminderInterval_$reflection()]], [["Item1", string_type], ["Item2", int32_type]], [["Item", bool_type]], [["Item1", string_type], ["Item2", int32_type]], [["Item", list_type(string_type)]], [["Item", list_type(string_type)]], [["Item", option_type(array_type(anonRecord_type(["color", string_type], ["label", string_type], ["value", LabelId_$reflection()])))]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

